{
  "title": "Tree Stride",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You gain the ability to enter a tree and move from inside it to inside another tree of the same kind within 500 feet.",
    "Both trees must be living and at least the same size as you. You must use 5 feet of movement to enter a tree. You instantly know the location of all other trees of the same kind within 500 feet and, as part of the move used to enter the tree, can either pass into one of those trees or step out of the tree you’re in. You appear in a spot of your choice within 5 feet of the destination tree, using another 5 feet of movement. If you have no movement left, you appear within 5 feet of the tree you entered.",
    "You can use this transportation ability once per round for the duration. You must end each turn outside a tree."
  ],
  "spellLists": ["druid", "ranger"]
}
